import { render, staticRenderFns } from "./ModalPopupInfo.vue?vue&type=template&id=36384364&"
import script from "./ModalPopupInfo.vue?vue&type=script&lang=js&"
export * from "./ModalPopupInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports